export default () => {
    return document.documentElement.lang.replace("_", "-");
};
